import { createSlice } from '@reduxjs/toolkit';
import { getIconsData } from '../data-provider';
import { IIcon, IIndexable, ISaveForLater } from '../../interfaces';
import { getFromLocalStorage, getFromSessionStorage, saveToLocalStorage, saveToSessionStorage } from '../storage';
import { restoreFromDeepLink } from '../../domain/deep-link-provider';

export interface IRootState{
    iconsData: IIndexable,
    randomIcon: IIcon|null,
    savedForLaterIcons: ISaveForLater[],
    category: string,
    randomizedButtonShaking: boolean,
    searchIconPopupShown: boolean,
}

// try to get data from local storage
const localStorageData = getFromLocalStorage();

// try to get data from session storage
const sessionStorageData = getFromSessionStorage();

const stateData: IRootState = {
    iconsData: getIconsData(),
    randomIcon: null,
    savedForLaterIcons: localStorageData || [],
    category: sessionStorageData?.category || '',
    randomizedButtonShaking: false,
    searchIconPopupShown: false,
};

restoreFromDeepLink(null, stateData);

/**
 * initial state
 */
const initialState: IRootState = stateData;

const rootSlice = createSlice({
    name: 'root',
    initialState,
    reducers: {

        main(state, action) {

            return {
                ...state,
                ...action.payload,
            };
        },

        saveForLaterIcons(state, action) {

            const updated = {
                ...state,
                savedForLaterIcons: action.payload,
            };

            // save to the session storage for the future use
            saveToLocalStorage(action.payload);

            return updated;
        },

        setCategory(state, action) {

            const updated = {
                ...state,
                category: action.payload,
            };

            // save to the session storage for the future use
            const current = getFromSessionStorage() || {};
            current.category = action.payload;
            saveToSessionStorage(current);

            return updated;
        },
    }
});

export default rootSlice;